/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    h3: "h3",
    h4: "h4",
    ul: "ul",
    li: "li",
    code: "code",
    pre: "pre",
    blockquote: "blockquote",
    h5: "h5",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Stylelint"
    }), "\n", _jsxs(_components.p, {
      children: ["Lint your ", _jsx(_components.a, {
        href: "https://github.com/styled-components/styled-components",
        children: "styled components"
      }), " with ", _jsx(_components.a, {
        href: "http://stylelint.io/",
        children: "stylelint"
      }), "!"]
    }), "\n", _jsx(_components.h3, {
      children: "Installation"
    }), "\n", _jsx(_components.h4, {
      children: "For stylelint v15+ (recommended)"
    }), "\n", _jsx(_components.p, {
      children: "Configuring stylelint (v15+) for the first time? Follow these steps:"
    }), "\n", _jsx(_components.p, {
      children: "You need:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "stylelint"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["The ", _jsx(_components.a, {
          href: "https://github.com/stylelint/stylelint-config-standard",
          children: "stylelint-config-standard"
        }), ", to extend the standard stylelint config"]
      }), "\n", _jsxs(_components.li, {
        children: ["The ", _jsx(_components.a, {
          href: "https://github.com/hudochenkov/postcss-styled-syntax",
          children: "postcss-styled-syntax"
        }), ", to parse your styled components and extract the CSS from them"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "npm install --save-dev \\\n  stylelint \\\n  stylelint-config-standard \\\n  postcss-styled-syntax\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Add a ", _jsx(_components.code, {
        children: ".stylelintrc"
      }), " file to the root of your project:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-JSON",
        children: "{\n  \"extends\": [\n    \"stylelint-config-standard\"\n  ],\n  \"customSyntax\": \"postcss-styled-syntax\"\n}\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "For stylelint v14 and below"
    }), "\n", _jsx(_components.p, {
      children: "You need:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "stylelint"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["The ", _jsx(_components.a, {
          href: "https://github.com/styled-components/stylelint-processor-styled-components",
          children: "stylelint-processor-styled-components"
        }), ", to extract styles from ", _jsx(_components.code, {
          children: "styled-components"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["The ", _jsx(_components.a, {
          href: "https://github.com/styled-components/stylelint-config-styled-components",
          children: _jsx(_components.code, {
            children: "stylelint-config-styled-components"
          })
        }), " to disable stylelint rules that clash with ", _jsx(_components.code, {
          children: "styled-components"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Your favorite ", _jsx(_components.code, {
          children: "stylelint"
        }), " config! (for example ", _jsx(_components.a, {
          href: "https://github.com/stylelint/stylelint-config-recommended",
          children: _jsx(_components.code, {
            children: "stylelint-config-recommended"
          })
        }), ")"]
      }), "\n"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "We recommend using Stylelint v9+ as this has added features that allow us to report correct line numbers on CSS syntax errors"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "npm install --save-dev \\\n  stylelint \\\n  stylelint-processor-styled-components \\\n  stylelint-config-styled-components \\\n  stylelint-config-recommended\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Add a ", _jsx(_components.code, {
        children: ".stylelintrc"
      }), " file to the root of your project:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-JSON",
        children: "{\n  \"processors\": [\n    \"stylelint-processor-styled-components\"\n  ],\n  \"extends\": [\n    \"stylelint-config-recommended\",\n    \"stylelint-config-styled-components\"\n  ]\n}\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Setup"
    }), "\n", _jsxs(_components.p, {
      children: ["You need to run ", _jsx(_components.code, {
        children: "stylelint"
      }), ". Add a ", _jsx(_components.code, {
        children: "lint:css"
      }), " script to your ", _jsx(_components.code, {
        children: "package.json"
      }), " which runs ", _jsx(_components.code, {
        children: "stylelint"
      }), " with a glob to all of your styled components:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-JSON",
        children: "{\n  \"scripts\": {\n    \"lint:css\":\"stylelint './src/**/*.js'\"\n  }\n}\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["The processor ignores javascript files that don't contain any ", _jsx(_components.code, {
          children: "styled-components"
        }), ", so don't worry about being too broad as long as you restrict it to javascript (or TypeScript)."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Now you can lint your CSS by running the script! 🎉"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "npm run lint:css\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Stylelint ", _jsx(_components.code, {
          children: "--fix"
        }), " option works with same rules on version 15+."]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      children: "Webpack"
    }), "\n", _jsxs(_components.p, {
      children: ["If you want to lint on build, rather than as a separate command, you can use the ", _jsx(_components.a, {
        href: "https://github.com/emilgoldsmith/stylelint-custom-processor-loader",
        children: _jsx(_components.code, {
          children: "stylelint-custom-processor-loader"
        })
      }), " for webpack."]
    }), "\n", _jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "stylelint-config-styled-components"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["When using this processor a couple of stylelint rules throw errors that cannot be prevented, like ", _jsx(_components.a, {
        href: "https://stylelint.io/user-guide/rules/no-empty-source",
        children: _jsx(_components.code, {
          children: "no-empty-source"
        })
      }), " or ", _jsx(_components.a, {
        href: "https://stylelint.io/user-guide/rules/no-missing-end-of-source-newline",
        children: _jsx(_components.code, {
          children: "no-missing-end-of-source-newline"
        })
      }), ". There's also a couple rules which we need to enforce, like ", _jsxs(_components.a, {
        href: "https://stylelint.io/user-guide/rules/property-no-vendor-prefix",
        children: [_jsx(_components.code, {
          children: "no-vendor-prefix"
        }), " rules"]
      }), ". (", _jsx(_components.code, {
        children: "styled-components"
      }), " automatically vendor prefixes your code, so you don't need to do it manually)"]
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.a, {
        href: "https://github.com/styled-components/stylelint-config-styled-components",
        children: _jsx(_components.code, {
          children: "stylelint-config-styled-components"
        })
      }), " will automatically disable rules that cause conflicts."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["You can override rules defined in shared configs in your custom ", _jsx(_components.code, {
          children: ".stylelintrc"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Usage with other libraries"
    }), "\n", _jsxs(_components.p, {
      children: ["Some other libraries also implement the ", _jsx(_components.code, {
        children: "styled.x"
      }), " pattern with tagged template literals. This processor will lint the CSS in those tagged template literals too, as long as they use the ", _jsx(_components.code, {
        children: "styled"
      }), " keyword."]
    }), "\n", _jsxs(_components.p, {
      children: ["If you want to use the processor with another library but you also want to change the keyword (e.g. to write ", _jsx(_components.code, {
        children: "cool.div"
      }), " instead of ", _jsx(_components.code, {
        children: "styled.div"
      }), ") use the ", _jsx(_components.code, {
        children: "moduleName"
      }), " option:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import cool from 'other-library';\n\nconst Button = cool.button`\n  color: blue;\n`;\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "{\n  \"processors\": [\n    [\n      \"stylelint-processor-styled-components\",\n      {\n        \"moduleName\": \"other-library\"\n      }\n    ]\n  ]\n}\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["That double array is on purpose but only necessary if you set options, see the ", _jsx(_components.a, {
          href: "https://stylelint.io/user-guide/configuration/#processors",
          children: "processors configuration docs"
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["We only officially support ", _jsx(_components.code, {
          children: "styled-components"
        }), ", but the hope is that other libraries can also benefit from the processor."]
      }), "\n"]
    }), "\n", _jsxs(_components.h3, {
      children: ["Interpolation tagging (with ", _jsx(_components.code, {
        children: "stylelint-processor-styled-components"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["Sometimes ", _jsx(_components.code, {
        children: "stylelint"
      }), " can throw an error (e.g. ", _jsx(_components.code, {
        children: "CssSyntaxError"
      }), ") even though nothing is wrong with your CSS. This is often due to an interpolation, more specifically the fact that the processor doesn't know what you're interpolating."]
    }), "\n", _jsx(_components.p, {
      children: "A simplified example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const something = 'background';\n\nconst Button = styled.div`\n  ${something}: papayawhip;\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["When you have interpolations in your styles the processor can't know what they are, so it makes a good guess and replaces them with a syntactically equivalent placeholder value. Since ", _jsx(_components.code, {
        children: "stylelint"
      }), " is not a code flow analysis tool this doesn't cover all edge cases and the processor will get it wrong every now and then."]
    }), "\n", _jsx(_components.p, {
      children: "Interpolation tagging allows you to tell the processor what an interpolation is in case it guesses wrong; it can then replace the interpolation with a syntactically correct value based on your tag."
    }), "\n", _jsx(_components.p, {
      children: "For example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const something = 'background';\n\nconst Button = styled.div`\n  // Tell the processor that \"something\" is a property\n  ${/* sc-prop */ something}: papayawhip;\n`;\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Now the processor knows that the ", _jsx(_components.code, {
        children: "something"
      }), " interpolation is a property, and it can replace the interpolation with a property for linting."]
    }), "\n", _jsxs(_components.p, {
      children: ["To tag an interpolation add a comment at either the start or the end of the interpolation. (", _jsx(_components.code, {
        children: "${/* sc-tag */ foo}"
      }), " or ", _jsx(_components.code, {
        children: "${bar /* sc-tag */}"
      }), ") Tags start with ", _jsx(_components.code, {
        children: "sc-"
      }), " and, if specified, a tag overrides the processors guess about what the interpolation is."]
    }), "\n", _jsx(_components.h4, {
      children: "Tags"
    }), "\n", _jsx(_components.p, {
      children: "The full list of supported tags:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "sc-block"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "sc-selector"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "sc-declaration"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "sc-property"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "sc-value"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["If you are in doubt of the vocabulary you can refer to ", _jsx(_components.a, {
          href: "https://developer.mozilla.org/en-US/docs/Web/CSS/Reference",
          children: "this CSS vocabulary list"
        }), " with examples."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "For example, when you interpolate another styled component, what you really interpolate is its unique selector. Since the processor doesn't know that, you can tell it to replace it with a selector when linting:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Wrapper = styled.div`\n  ${/* sc-selector */ Button} {\n    color: red;\n  }\n`;\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "You can also use shorthand tags to avoid cluttering the code. For example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Wrapper = styled.div`\n  ${/* sc-sel */ Button} {\n    color: red;\n  }\n`;\n"
      })
    }), "\n", _jsx(_components.h5, {
      children: _jsx(_components.code, {
        children: "sc-custom"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "sc-custom"
        }), " is meant to be used as a last resort escape hatch. Prefer to use the standard tags if possible!"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["On top of the above standard tags the processor also has the ", _jsx(_components.code, {
        children: "sc-custom"
      }), " tag to allow you to cover more unique and uncommon edge cases. With the ", _jsx(_components.code, {
        children: "sc-custom"
      }), " tag you can decide yourself what the placeholder value will be."]
    }), "\n", _jsx(_components.p, {
      children: "For example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "// Switch between left and right based on language settings passed through via the theme\nconst rtlSwitch = (props) => (props.theme.dir === 'rtl' ? 'left' : 'right');\n\nconst Button = styled.button`\n  background: green;\n  // Tell the processor to replace the interpolation with \"left\"\n  // when linting\n  margin-${/* sc-custom \"left\" */ rtlSwitch}: 12.5px;\n`;\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Syntax notes"
    }), "\n", _jsx(_components.h4, {
      children: "Turning rules off from within your JS/CSS"
    }), "\n", _jsxs(_components.p, {
      children: ["Turn off rules with ", _jsx(_components.code, {
        children: "stylelint-disable"
      }), " comments (see the ", _jsx(_components.a, {
        href: "https://stylelint.io/user-guide/configuration/#turning-rules-off-from-within-your-css",
        children: "stylelint documentation"
      }), " for all allowed syntax) both inside and outside of the tagged template literals."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import React from 'react';\nimport styled from 'styled-components';\n\n// Disable stylelint from within the tagged template literal\nconst Wrapper = styled.div`\n  /* stylelint-disable */\n  background-color: 123;\n`;\n\n// Or from the JavaScript around the tagged template literal\n/* stylelint-disable */\nconst Wrapper = styled.div`\n  background-color: 123;\n`;\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Template literal style and indentation"
    }), "\n", _jsx(_components.p, {
      children: "In order to have stylelint correctly apply indentation rules the processor needs to do a bit of opinionated preprocessing on the styles, which results in us only officially supporting one indentation style. (the supported style is the \"default\" one as shown in all the documentation)"
    }), "\n", _jsx(_components.p, {
      children: "The important thing is that you put the closing backtick on the base level of indentation as follows:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Right"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "if (condition) {\n  const Button = styled.button`\n    color: red;\n  `;\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Wrong"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "if (condition) {\n  const Button = styled.button`\n    color: red;\n`\n}\n"
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "if (condition) {\n  const Button = styled.button`\n    color: red;`\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "It may be that other tagged template literal styles are coincidentally supported, but no issues will be handled regarding indentation unless the above style was used."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
